import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { useQuery } from '@tanstack/react-query';
import { triContainer } from '../../di/container';
import { authContainer } from '@/modules/auth/di/container';

export function useClassTri(editionId: string) {
  const { institutionName } = useInstitutionStore();

  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: ['tri', 'class-tri', institutionName, editionId],
    queryFn: () => triContainer.repository.getClassTri(editionId),
    enabled: isAuthenticated && !!editionId,
    retry: false,
  });
}
